export default __webpack_public_path__ + "static/media/ExcelTemplate1.f53e6443.xlsx";